import { render, staticRenderFns } from "./TransportPL.vue?vue&type=template&id=897e721e&scoped=true&"
import script from "./TransportPL.vue?vue&type=script&lang=js&"
export * from "./TransportPL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897e721e",
  null
  
)

export default component.exports